import { defineMessage } from 'services/localization';

export const messages = {
    approverApproved: defineMessage('this_request_was_previously_approved_by_you'),
    requesterUpdatedWithReset: defineMessage('this_request_was_previo_mitted_by_the_requester'),
    requesterResetTemplate: defineMessage('this_request_was_previo_l_process_was_restarted'),
    updatedExternallyResetTemplate: defineMessage('this_request_was_previo_n_the_accounting_system'),
    editRequestButtonText: defineMessage('edit_the_bill'),
    editRequestNoticeText: defineMessage('please_fill_in_the_miss_emplatenameendadornment'),
    dextNewSupplierWarning: defineMessage('please_note_this_reques__approving_this_request'),
    ocrInProgressText: defineMessage('capturing_in_progress_it_may_take_up_to_minutes'),
};
